var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B4B4B4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.852 9l.926 3H8.222l.926-3h5.704zm-.926-3h-3.852l.631-2.044a1.355 1.355 0 012.59 0L13.926 6zm2.778 9l1.235 4H6.06l1.235-4h9.408z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    opacity: 0.3,
    rx: 1,
    transform: "translate(3 20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFix);
export default __webpack_public_path__ + "static/media/fix.a0d89015d24c020322c70e7b66e62902.svg";
export { ForwardRef as ReactComponent };